
import eventTrackingMixins from '~/mixins/eventTrackingMixins.js';

export default {
  name: "QdapHomeQuestionnaireQuestion",
  mixins: [eventTrackingMixins],
  props: {
    stateId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      questionNo: 1,
      questionText: this.$i18n.t('qdap.questionnaire.questions'),
      selectedItem: {},
      selectedResult: {},
    }
  },
  computed: {
    questionData() {
      const questionIndex = this.questionNo - 1;
      return {
        question: this.questionText[questionIndex].question,
        questionRemark: this.questionText[questionIndex].questionRemark,
        type: this.questionText[questionIndex].placeholder ? 'dropdown': 'option',
        placeholder: this.questionText[questionIndex].placeholder,
        tips: this.questionText[questionIndex].tips,
        answer: this.getAnswerList,
      }
    },
    dropdownData() {
      if ( this.questionData.type === 'dropdown') {
        const data = {
          placeholder: this.questionData.placeholder,
          answer: this.questionData.answer,
        }
        if ( this.getRelation !== false ) {
          data.relation = this.getRelation;
          data.relation.value = this.selectedResult[this.getRelation.question];
        }
        return data;
      } else {
        return false;
      }
    },
    activeBtnNext() {
      return this.selectedItem.value || this.selectedResult[this.questionNo] !== undefined;
    },
    getRelation() {
      // set reset = true if need reset the relation question
      // set compare = '>'/'<' to compare with relative value
      if ( this.questionNo === 1 ) {
        return {
          question: 3,
          compare: '>',
          reset: true,
        }
      } else if ( this.questionNo === 3 ) {
        return {
          question: 1,
          compare: '>',
          maxValue: this.selectedResult[1] + 10,
          reset: false,
        }
      } else {
        return false;
      }
    },
    getAnswerList() {
      const questionIndex = this.questionNo - 1;
      if (this.questionNo === 1 ) {
        const finalRange = [];
        const unit = this.questionText[questionIndex].answer[0];
        for (let i = 17; i < 55; i++) {
         finalRange.push({
          text: `${i + 1}${unit}`,
          value: i + 1
         });
        }
        return finalRange;
      } else if ( this.questionNo === 3) {
        return [
          {
            text: this.questionText[questionIndex].answer[0],
            value: 50,
          },
          {
            text: this.questionText[questionIndex].answer[1],
            value: 55,
          },
          {
            text: this.questionText[questionIndex].answer[2],
            value: 60,
          },
          {
            text: this.questionText[questionIndex].answer[3],
            value: 65,
          },
        ]
      } else if ( this.questionNo === 4) {
        return [
          {
            text: this.questionText[questionIndex].answer[0],
            value: 10,
          },
          {
            text: this.questionText[questionIndex].answer[1],
            value: 20,
          },
          {
            text: this.questionText[questionIndex].answer[2],
            value: 999,
          },
        ]
      } else {
        return this.questionText[questionIndex].answer;
      }
    },
    getSelectedResult() {
      return this.selectedResult[this.questionNo];
    }
  },
  watch: {
    questionNo(newVal, oldVal) {
      if (newVal) {
        this.selectedItem = {};
      }
    },
  },
  methods: {
    goPrevPage(page) {
      this.questionNo -= 1;
    },
    goNextPage(page) {
      if ( this.questionNo <= 3 ) {
        this.questionNo += 1;
      }
    },
    updateSelected(item) {
      this.selectedItem = item;

      if ( this.selectedItem.value ) {
        const item = {
          id: this.questionNo,
          text: this.selectedItem.text,
          value: this.selectedItem.value,
        }
        this.$emit('update-selected-items', item);
        this.selectedResult[item.id] = item.value;
      }

      // if contains relation question, check selected result with compare relation question value
      if ( this.getRelation !== false && this.getRelation.reset ) {
        if ( this.getRelation.compare !== undefined && this.getRelation.compare === '>' ) {
          if ( this.selectedResult[this.questionNo] + 10 > this.selectedResult[this.getRelation.question]) delete this.selectedResult[this.getRelation.question];
        }
      }

      if ( this.questionNo === 1 && this.selectedResult[1]) {
        this.handleTracking('age', this.selectedResult[1], 'qdap_questionnaire', this.stateId);
      }
      if ( this.questionNo === 2 && this.selectedResult[2]) {
        if ( this.selectedResult[2] === 1) {
          this.handleTracking('objective', 'breakeven', 'qdap_questionnaire', this.stateId);
          // Show saving products page
          this.$emit('update-page', 'products');
        } else {
          this.handleTracking('objective', 'income', 'qdap_questionnaire', this.stateId);
        }
      }
      if ( this.questionNo === 4 && this.selectedResult[4] ) {
        this.$emit('update-page', 'products');
      }

      this.goNextPage();
    },
    handleTracking(event, label, value, stateId) {
      const eventTrackingParams = this.initEventTrackingParams();

      eventTrackingParams.a = event;
      eventTrackingParams.l = label;
      eventTrackingParams.c = value;
      eventTrackingParams.xr_id = stateId;

      this.sendEventTracking(eventTrackingParams);
    },
  }
}
